import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-country-flag',
  templateUrl: './country-flag.component.html',
  styleUrls: ['./country-flag.component.scss']
})
export class CountryFlagComponent {
  @Input() country: string = '';
  @Input() width: number = 20;
}
